export default __webpack_public_path__ + "static/media/portal-app-icon.f4402790.svg";